import * as React from "react";
import { JsonDateParser } from "../../../../../../react-core/Utils/JsonDateParser";
import { SubAccountType } from "../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { GiaContributionModel } from "../../../../../../Wrap/Models/Models/Processes/Apply/PersonalPortfolio/GiaContributionModel";
import { IsaContributionModel } from "../../../../../../Wrap/Models/Models/Processes/OneOffPayment/Isa/IsaContributionModel";
import { ProcessType } from "../../../../../Shared/IST/Resource/Content";
import { IProcessComponentProps, ProcessComponent } from "../../../../../Shared/Process/Process/ProcessComponent";
import { Typography } from "../../../../../Shared/Typography/Typography";
import { getQueryParameters, setQueryParameters } from "../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { Urls } from "../../../../Urls";
import { subAccountTypeMap } from "../../PortfolioDashboard/Components/Performance/Resource/Contents";
import { AdHocAdviserChargeReview } from "../../Common/Review/Component/AdHocAdviserChargeReview";
import { AdviceChargeReview } from "../../Common/Review/Component/AdviceChargeReview";
import { InvestmentReview } from "../../Common/Review/Component/InvestmentReview";
import { OneOffWithdrawalReview } from "../../Common/Review/Component/OneOffWithdrawalReview";
import { PaymentsInReview } from "../../Common/Review/Component/PaymentsInReview";
import { WithDrawalReview } from "../../Common/Review/Component/WithDrawalReview";
import { WhatIfAction } from "../Action/WhatIfAction";
import { whatifProcess } from "../Resource/Contents";
import { IllustrationsAvailable } from "../../Common/Documents/Components/IllustrationsAvailable";
import { InstructionDocumentTypeRequestTriggerActionsCreator } from "../../Common/Documents/Actions/InstructionDocumentTypeRequestTriggerActionsCreator";
import { DocumentCategory } from "../../../../../../Wrap/Constants/Enums/Domain/DocumentCategory";
import { OneOffIncomePaymentReview } from "../../Common/Review/Component/OneOffIncomePaymentReview";
import { PensionContributionModel } from "../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionContributionModel";
import { Document } from "./Document";
import { IncomePaymentReview } from "../../Common/Review/Component/IncomePaymentReview";
import { AccountsConversionTable } from "../../Common/ConvertCappedToFlexi/WhatIfAccountsConversionTable";
import { CappedPensionArrangementsFlexiConversionAvailability } from "../../../../../../Wrap/Models/Domains/Drawdown/CappedPensionArrangementsFlexiConversionAvailability";
import { DrawdownReview } from "../../Common/Review/Component/DrawdownReview";
import { hasEnhancedPensionProtection, showChooseAssetstoSell } from "../../Common/SIPP/DrawdownDetails/Helper/DrawdownDetailHelper";
import { PensionOption } from "../../../../../../Wrap/Constants/Enums/Apply/PensionOption";
import { ChooseAssetsToSellFor } from "../../Common/SIPP/DrawdownDetails/Resource/Contents";

interface IReviewProps extends IProcessComponentProps {
    data: GiaContributionModel | IsaContributionModel | PensionContributionModel;
    type: SubAccountType;
    cappedPensionArrangementsFlexiConversions: CappedPensionArrangementsFlexiConversionAvailability[]
}

interface IReviewState {}

export class Review extends ProcessComponent<IReviewProps, IReviewState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    private getStepReviewProps = () => {
        return {
            data: this.props.data?.Contribution,
            subAccountType: this.props.type,
            process: ProcessType.WhatIf,
            colNum: 2,
        };
    };

    componentDidMount() {
        super.componentDidMount();

        InstructionDocumentTypeRequestTriggerActionsCreator.triggerByInstructionId(
            getQueryParameters()["id"] as string,
            [DocumentCategory.Illustration]
        );
    }

    private copyInstruction(path: string) {
        const { data, type } = this.props;
        const params = getQueryParameters();
        WhatIfAction.copyInstruction(data?.HierarchyId, params["subaccounthierarchyid"], type, (id) => {
            params["id"] = id;
            window.location.assign(path + setQueryParameters(params));
        });
    }
    private showAssetsToSell = () => {
        return showChooseAssetstoSell(this.props.data?.Contribution?.["DrawdownModel"], ChooseAssetsToSellFor.Drawdown);
    };

    private successLabelRender() {
        const { data, type } = this.props;
        const createdDate = JsonDateParser.getFormatDateString(new Date(), "dd MM yyyy", true);
        const reference = data?.HierarchyId;
        const selectedModel = (data?.Contribution?.ChangesToBeModeled || "").split(",");
        const config = [
            {
                title: "Created:",
                data: createdDate,
            },
            {
                title: "Wrapper:",
                data: subAccountTypeMap[type],
            },
        ];
        return (
            <div>
                {selectedModel.includes(whatifProcess.ConvertCappedToFlexi) &&
                    (<AccountsConversionTable
                        data={data}
                        cappedToFlexiArrangementDetails={this.props.cappedPensionArrangementsFlexiConversions}
                        onChange={(v) => {}}
                        onRef={(ref) => this.appendChild(ref)}
                        isReviewStep={true}
                        isReview={true}
                    />)}
                <h1>
                    <span className="alert-success">Illustration {reference} successfully created</span>
                </h1>
                <br />
                <h2>Illustration No. {reference}</h2>
                <Typography type="narrow-dt-width" wrapCss="quote-list" config={config}></Typography>
                <IllustrationsAvailable onRef={(ref) => this.appendChild(ref)} onChange={() => {}} data={data} />
            </div>
        );
    }

    render() {
        const { data, type } = this.props;
        return (
            <>
                {this.successLabelRender()}
                <Document {...this.props} />
                {data?.Contribution?.ChangesToBeModeled.includes(whatifProcess.editPaymentIn) && (
                    <PaymentsInReview
                        {...this.getStepReviewProps()}
                        onEditAction={() => this.copyInstruction(Urls.get().WhatIfToolPaymentsIn.getFullRoutePath())}
                    />
                )}
                {data?.Contribution?.ChangesToBeModeled.includes(whatifProcess.editAdviserCharges) && (
                    <AdviceChargeReview
                        {...this.getStepReviewProps()}
                        onEditAction={() => this.copyInstruction(Urls.get().WhatIfToolAdviserCharge.getFullRoutePath())}
                    />
                )}
                {data?.Contribution?.ChangesToBeModeled.includes(whatifProcess.AddAdditionalAdviserCharge) && (
                    <AdHocAdviserChargeReview
                        {...this.getStepReviewProps()}
                        onEditAction={() => this.copyInstruction(Urls.get().WhatIfToolAdHocCharge.getFullRoutePath())}
                    />
                )}
                {data?.Contribution?.ChangesToBeModeled.includes(whatifProcess.editInvestmentSeletion) && (
                    <InvestmentReview
                        {...this.getStepReviewProps()}
                        onEditAction={() =>
                            this.copyInstruction(Urls.get().WhatIfToolInvestmentSelection.getFullRoutePath())
                        }
                    />
                )}
                {data?.Contribution?.ChangesToBeModeled.includes(whatifProcess.AddOneOffWithdrawal) && (
                    <OneOffWithdrawalReview
                        {...this.getStepReviewProps()}
                        onEditAction={() =>
                            this.copyInstruction(Urls.get().WhatIfToolOneOffWithdrawal.getFullRoutePath())
                        }
                    />
                )}
                {data?.Contribution?.ChangesToBeModeled.includes(whatifProcess.TakePensionBenefits) && (
                    <DrawdownReview
                        showDrawdownPriceLock={true}
                        showAssetsToSell={this.showAssetsToSell()}
                        modelData={this.props.data}
                        isImmediateLumpSum={false}
                        colNum={3}
                        process={ProcessType.TakePensionBenefits}
                        data={this.props.data.Contribution}
                        onEditAction={() =>
                            this.copyInstruction(Urls.get().WhatIfToolTakePensionBenefits.getFullRoutePath())
                        }
                        hasEnhancedPensionProtection={hasEnhancedPensionProtection(data?.Contribution)}
                    />
                )}

                {data?.Contribution?.ChangesToBeModeled.includes(whatifProcess.TakePensionBenefits) &&
                    data?.Contribution?.["DrawdownModel"].PensionOption != PensionOption.UFPLS && (
                        <IncomePaymentReview
                            colNum={3}
                            process={ProcessType.TakePensionBenefits}
                            data={this.props.data.Contribution}
                            model={this.props.data}
                            onEditAction={() =>
                                this.copyInstruction(Urls.get().WhatIfToolTakePensionBenefits.getFullRoutePath())
                            }
                            isITFC={false}
                        />
                    )}
                {data?.Contribution?.ChangesToBeModeled.includes(whatifProcess.EditIncomeDrawdown) && (
                    <DrawdownReview
                        showDrawdownPriceLock={true}
                        showAssetsToSell={this.showAssetsToSell()}
                        colNum={3}
                        process={ProcessType.EditIncomeDrawdown}
                        data={this.props.data.Contribution}
                        modelData={this.props.data}
                        isImmediateLumpSum={false}
                        onEditAction={() =>
                            this.copyInstruction(Urls.get().WhatIfToolEditIncomeDrawdown.getFullRoutePath())
                        }
                        hasEnhancedPensionProtection={hasEnhancedPensionProtection(data?.Contribution)}
                    />
                )}
                {data?.Contribution?.ChangesToBeModeled.includes(whatifProcess.EditIncomeDrawdown) && (
                    <IncomePaymentReview
                        colNum={3}
                        process={ProcessType.TakePensionBenefits}
                        data={this.props.data.Contribution}
                        model={this.props.data}
                        onEditAction={() =>
                            this.copyInstruction(Urls.get().WhatIfToolEditIncomeDrawdown.getFullRoutePath())
                        }
                        isITFC={false}
                    />
                )}
                {data?.Contribution?.ChangesToBeModeled.includes(whatifProcess.AddEditRegularWithdrawals) && (
                    <WithDrawalReview
                        {...this.getStepReviewProps()}
                        onEditAction={() =>
                            this.copyInstruction(Urls.get().WhatIfToolRegularWithdrawal.getFullRoutePath())
                        }
                    />
                )}
                {data?.Contribution?.ChangesToBeModeled.includes(whatifProcess.EditIncomePayments) && (
                    <IncomePaymentReview
                        colNum={3}
                        process={ProcessType.WhatIf}
                        data={this.props.data.Contribution}
                        model={this.props.data}
                        onEditAction={() =>
                            this.copyInstruction(Urls.get().WhatIfToolEditIncomePayments.getFullRoutePath())
                        }
                        isITFC={false}
                    />
                )}
                {data?.Contribution?.ChangesToBeModeled.includes(whatifProcess.SIPPOneOffIncomePayment) && (
                    <OneOffIncomePaymentReview
                        {...this.getStepReviewProps()}
                        data={data}
                        onEditAction={() =>
                            this.copyInstruction(Urls.get().WhatIfOneOffIncomePayment.getFullRoutePath())
                        }
                    />
                )}
            </>
        );
    }
}
